export default __webpack_public_path__ + "static/media/Trinket of Sharpened Blades.d5c42d9b.jpg";